import { Box, LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CountProgress = (props) => {
    const { t } = useTranslation();
    const { count, total } = props;
  
    const getValue = () => {
        const val = count * 100 / total;
        return val > 100 ? 100 : parseInt(val);
    };

    return (
        (total === 'inf') ? (
            <>
            </>
        ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', my: 'auto', width: '100%' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress color={getValue() === 100 ? 'error' : 'success' } sx={{ height: 10, borderRadius: 1 }} variant="determinate" value={getValue()} />
                </Box>
                <Box sx={{ minWidth: 45 }}>
                    <Typography variant="body2" color="text.secondary">
                        <span style={{ fontWeight: 400 }}>{count}</span> {t('of')} {total}
                    </Typography>
                </Box>
            </Box>
        )
        
    );
};

export default CountProgress;